import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface UploadResult {
  url: string;
  fileName: string;
  size: number;
}

export const filesApi = {
  /** Upload a single document; returns its URL (store in the *_url field) + original name. */
  async upload(file: File): Promise<UploadResult> {
    const form = new FormData();
    form.append('file', file);
    // Let the browser set the multipart boundary — do NOT set Content-Type manually.
    const { data } = await apiClient.post<ApiSuccess<UploadResult>>('/files/upload', form);
    return data.data;
  },
};
